import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Breadcrumb from "../Component/Breadcrumb"

const CampusInformation = () => {
    
    return (
        <>
            <Header />
            <Breadcrumb title="Campus Information" midBreadcrumb="Disclosure" mainBreadcrumb="Campus Information" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div className="row">
                        <div className="col-12">
                            <h2 className="mainhead">Campus Information</h2>
                        </div>
                        <div className="col-lg-6">
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <td colspan="2"><strong>1. Area of School Campus</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>(i) In acres</td>
                                            <td>2.3 Acres</td>
                                        </tr>
                                        <tr>
                                            <td>(ii) In sq. mtrs.</td>
                                            <td>9578 sq. mts.</td>
                                        </tr>
                                        <tr>
                                            <td>(iii) Built up are (sq. mts)</td>
                                            <td>25000 sq. ft.</td>
                                        </tr>
                                        <tr>
                                            <td>(iv) Area of playground in sq. mts.</td>
                                            <td>2813 sq. mts.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <td colspan="2"><strong>2. Library Facilities</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>(i) Size of the Libarary in Sq. feet</td>
                                            <td>1000 Sq. Ft.</td>
                                        </tr>
                                        <tr>
                                            <td>(ii) No. of Periodicals</td>
                                            <td>14</td>
                                        </tr>
                                        <tr>
                                            <td>(iii) Dance Room</td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>(iv) No. of Dailies</td>
                                            <td>8</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <td colspan="2"><strong>3. Transport Facility</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>(i) Own Buses</td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>(ii) Buses hired on Contract Basis</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>(iii) Details of Transport Charges</td>
                                            <td>Rs. 1200/- to Rs. 1750/-</td>
                                        </tr>
                                        <tr>
                                            <td><strong>6. Academic Session Period</strong></td>
                                            <td>April to March</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <td colspan="2"><strong>4. Mode of Payment of Salary</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>(i) Name of the bank through which salary is drawing</td>
                                            <td>Punjab National Bank</td>
                                        </tr>
                                        <tr>
                                            <td>(ii) Through Single Cheque transfer advice</td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>(iii) Individual Cheque</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>(iv) Cash</td>
                                            <td>No</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <td colspan="2"><strong>5. Other Facilities</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>(i) Swimming Pool</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>(ii) Indoor Games</td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>(iii) Dance Room</td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>(iv) Gymnasium</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>(v) Music Room</td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>(vi) Hostel
                                            </td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>(vii) Health &amp; Medical Checkup</td>
                                            <td>Yes</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td>7. Vacation Period</td>
                                            <td>June to June&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>8. Admission Period</td>
                                            <td>March to May</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default CampusInformation